import React from "react";

import { ReactComponent as BackButtonIcon } from "../../assets/images/app/allaya/left-arrow-icon.svg";

const HeaderWithBackButton = ({ title, onBackClick }) => {
    return (
        <div className="d-flex align-items-center mx-4 mb-4">
            <div className="border-0 p-0  pointer" onClick={onBackClick}>
                <BackButtonIcon />
            </div>
            <h4 className="m-0 px-3">{title}</h4>
        </div>
    );
};

export default HeaderWithBackButton;
